import {connect} from 'react-redux';
import {GlassTube as Component} from './GlassTube';
import {
  createGlassTube,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("glassTubes") &&
     state.notebook.protocolSection.scene.apparatus.glassTubes.some(
       box => box.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.glassTubes[ownProps.id-1].type,
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createGlassTube: (data)=>{
      dispatch(createGlassTube(data))
    },
  };
}

export const GlassTube = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
